import React from "react";

const community = () => {
  return (
    <div className="container grand_parent_div_text">
      <h2 className="text-center">Community Guidelines</h2>
      <p>
        Digital art support system is built based on the mutual respect between
        the creators, curators and the collectors. MMO NFT Marketplaces is a cultural
        community that wants everyone to agree on the basic key rules and the
        expectations. We hope you can embody all our ideals and help develop a
        welcoming community that empowers creators and the collectors.
      </p>
      <h6>For the community</h6>
      To break from the old and start something truly new, we must be led by
      values of kindness and inclusivity. Showing respect and care towards one
      another is of utmost importance to all of us as we build a community that
      is welcoming to all. Showing respect and care and building an effective
      community is our priority. Our primary wish is to break from the old and
      start something new and astounding that is led by the value of kindness
      and inclusivity
      <h6>For Creators</h6>
      <p>
        MMO NFT Marketplace gives utmost importance to creators and creator’s
        perspectives.We take this seriously because building trust is essential
        to sustaining a healthy community. When you mint and sell an NFT on
        MMO NFT Marketplace: The creators can maintain all the legal rights, including
        trademarks and copyrights of their original work. The creators have all
        rights to reproduce, distribute and exhibit and make derivative work of
        your art. What you can’t do as a creator: Creators can't upload anyone
        else’s copyrighted or proprietary work. Creators can't create additional
        NFT’s that could represent the same art piece. We do accept related
        works in a series that are totally accepted.
      </p>
      <h6>For Collectors</h6>
      <p>
        Collectors in NFT space can explore new cultural paradigms and art
        models with the aid of forward-thinking approaches. Once the collectors
        win an auction, you will receive an unique NDT from the artist you want
        to support and champion. When you collect an NFT on MMO NFT Marketplace:
        Collectors can own the NFT that represents the artwork on blockchain.
        Collectors can display and share the art piece Collectors can exhibit
        their art work on any platform or any virtual space in general.
        Collectors can resell or trade it on second market What you can’t do as
        a collector: Collectors can’t claim legal ownership, copyrights,
        trademarks, or other intellectual property rights. One can’t use the
        artwork in a commercial context. You make any changes to the artwork.
        Collectors share the work in a hateful, cruel, or intolerant context.
        You can’t create additional NFTs that represent the same artwork. As
        creators and collectors we do have responsibility to create a positive
        environment. In short version, we would like the members of our
        community to not lie, spam, steal, cause harm or anything hateful. If
        you find any kind of such activities, feel free to reach us through. If
        we determine a creator is doing any of these things, we will mediate the
        situation which may include account suspension.
      </p>
    </div>
  );
};

export default community;
